export const formatFieldCapital = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
